export enum WinningTabs {
  TOP_24H = 0,
  LAST_WINS = 1,
}
